import { render, staticRenderFns } from "./customValidateTextarea.vue?vue&type=template&id=bfe81952&scoped=true&"
import script from "./customValidateTextarea.vue?vue&type=script&lang=js&"
export * from "./customValidateTextarea.vue?vue&type=script&lang=js&"
import style0 from "./customValidateTextarea.vue?vue&type=style&index=0&id=bfe81952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe81952",
  null
  
)

export default component.exports